import React from 'react';

import Doublestationextrusion from './Doublestationextrusion';
import Ebblowapplicat from './Ebblowapplicat';
import Featblow from './Featblow';
import Blowtable from './Blowtable';


const Ebseriesextrusion = () => {
  return (
    <div>
       <Doublestationextrusion />
            <Ebblowapplicat />
            <Featblow />
            <Blowtable />
    </div>
  );
};

export default Ebseriesextrusion;
